// @ts-nocheck
(function () {
  if (window.__ugProductCardTabs) return;
  window.__ugProductCardTabs = true;

  function initProductCardTabs(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-ug-pc-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ugPcTabsBound === 'true') return;
      wrap.dataset.ugPcTabsBound = 'true';

      const tabs = wrap.querySelectorAll('.ug-pc-tabs__btn[role="tab"]');
      const panels = wrap.querySelectorAll('.ug-pc-tabs__panel[role="tabpanel"]');
      if (tabs.length === 0 || panels.length === 0) return;

      function centerActiveTab(tab, index) {
        if (!window.matchMedia('(max-width: 1023.98px)').matches) return;

        const scroller = tab.closest('[data-ug-pc-tabs-nav-outer]');
        if (!(scroller instanceof HTMLElement)) return;

        const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        if (maxScroll <= 1) return;

        let target;
        if (index === 0) {
          target = 0;
        } else if (index === tabs.length - 1) {
          target = maxScroll;
        } else {
          const scrollerRect = scroller.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          target =
            scroller.scrollLeft +
            (tabRect.left - scrollerRect.left) -
            (scroller.clientWidth - tabRect.width) / 2;
          target = Math.max(0, Math.min(target, maxScroll));
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scroller.scrollTo({
          left: target,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      function activate(index) {
        tabs.forEach(function (t, i) {
          const on = i === index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, i) {
          if (i === index) {
            p.classList.remove('ug-pc-tabs__panel--hidden');
          } else {
            p.classList.add('ug-pc-tabs__panel--hidden');
          }
        });
        const active = tabs[index];
        if (active instanceof HTMLElement) {
          if (wrap.hasAttribute('data-ug-pc-center-active-tab')) {
            centerActiveTab(active, index);
          } else if (typeof active.scrollIntoView === 'function') {
            try {
              active.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
            } catch (err) {
              active.scrollIntoView(false);
            }
          }
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(i);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductCardTabs(document);
    });
  } else {
    initProductCardTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductCardTabs(event.target);
  });
})();

(function () {
  if (window.__ugProductCardGridExpand) return;
  window.__ugProductCardGridExpand = true;

  function mergeCardThemeFromSectionEl(sectionEl) {
    const data = sectionEl.querySelector('[data-ug-pc-theme-data]');
    const jsonEl = sectionEl.querySelector('[data-ug-pc-theme-json]');
    let jsonTheme = {};
    if (jsonEl) {
      const raw = jsonEl.textContent && jsonEl.textContent.trim();
      if (raw) {
        try {
          jsonTheme = JSON.parse(raw);
        } catch (e) {}
      }
    }
    let theme = Object.assign({}, jsonTheme);
    if (data) {
      theme = Object.assign({}, theme, {
        addToCart: data.getAttribute('data-add-to-cart') || theme.addToCart,
        buyNow: data.getAttribute('data-buy-now') || theme.buyNow,
        capsuleLeft: data.getAttribute('data-capsule-left') || theme.capsuleLeft,
        fusedLink: data.getAttribute('data-fused-link') || theme.fusedLink,
        off: data.getAttribute('data-off') || theme.off,
        copy: data.getAttribute('data-copy') || theme.copy,
        copied: data.getAttribute('data-copied') || theme.copied,
        soldOut: data.getAttribute('data-sold-out') || theme.soldOut,
        expandLabel: data.getAttribute('data-expand-label') || theme.expandLabel,
        collapseLabel: data.getAttribute('data-collapse-label') || theme.collapseLabel,
        linkLabel: data.getAttribute('data-link-label') || theme.linkLabel,
        badgeImage: data.getAttribute('data-badge-image') || theme.badgeImage
      });
    }
    return theme;
  }

  function applyThemeToSectionEl(sectionEl, theme) {
    if (!theme) return;

    if (theme.linkLabel) {
      sectionEl.querySelectorAll('.ug-pc__grid-cta--link .ug-pc__grid-cta__label').forEach(function (el) {
        el.textContent = theme.linkLabel;
      });
    }

    if (theme.off) {
      sectionEl.querySelectorAll('[data-ug-pc-theme-text="off"]').forEach(function (el) {
        el.textContent = theme.off;
      });
    }

    if (theme.copy || theme.copied) {
      sectionEl.querySelectorAll('[data-ug-pc-theme-text="copy"]').forEach(function (btn) {
        if (theme.copy) {
          btn.setAttribute('data-copy-text', theme.copy);
          btn.setAttribute('aria-label', theme.copy);
          if (!btn.classList.contains('is-copied')) btn.textContent = theme.copy;
        }
        if (theme.copied) btn.setAttribute('data-copied-text', theme.copied);
      });
    }

    if (theme.badgeImage) {
      sectionEl.querySelectorAll('.ug-pc-card__badge-icon[data-ug-pc-badge-source="default"]').forEach(function (img) {
        img.setAttribute('src', theme.badgeImage);
      });
    }

    if (theme.addToCart || theme.buyNow || theme.capsuleLeft || theme.fusedLink || theme.soldOut) {
      sectionEl.querySelectorAll('.ug-pc-card__buttons').forEach(function (wrap) {
        if (theme.fusedLink) {
          wrap.querySelectorAll('.ug-pc-theme-text-fused-link .ug-btn__label').forEach(function (el) {
            el.textContent = theme.fusedLink;
          });
        }
        if (theme.capsuleLeft) {
          wrap.querySelectorAll('.ug-pc-theme-text-capsule-left .ug-btn__label').forEach(function (el) {
            el.textContent = theme.capsuleLeft;
          });
        }
        if (theme.soldOut) {
          wrap.querySelectorAll('.ug-pc-theme-text-sold-out .ug-btn__label').forEach(function (el) {
            el.textContent = theme.soldOut;
          });
        }
        if (theme.addToCart) {
          wrap.querySelectorAll('.ug-pc-theme-text-add-to-cart .ug-btn__label').forEach(function (el) {
            el.textContent = theme.addToCart;
          });
        }
        if (theme.buyNow) {
          wrap.querySelectorAll('.ug-pc-theme-text-buy-now .ug-btn__label').forEach(function (el) {
            el.textContent = theme.buyNow;
          });
        }
      });
    }
  }

  function listUgPcSections(scopeRoot) {
    const scope = scopeRoot || document;
    if (
      scopeRoot &&
      scopeRoot.nodeType === 1 &&
      scopeRoot.classList &&
      scopeRoot.classList.contains('ug-pc-section')
    ) {
      return [scopeRoot];
    }
    return Array.prototype.slice.call(scope.querySelectorAll('.ug-pc-section'));
  }

  function applyGlobalTheme(root) {
    listUgPcSections(root || document).forEach(function (sectionEl) {
      applyThemeToSectionEl(sectionEl, mergeCardThemeFromSectionEl(sectionEl));
    });
  }

  function bindGridExpand(root) {
    listUgPcSections(root || document).forEach(function (sectionEl) {
      const theme = mergeCardThemeFromSectionEl(sectionEl);
      sectionEl.querySelectorAll('[data-ug-pc-grid-expand]').forEach(function (btn) {
        if (btn.dataset.ugPcGridExpandBound === 'true') return;
        btn.dataset.ugPcGridExpandBound = 'true';

        if (theme.expandLabel) {
          btn.setAttribute('data-ug-pc-label-expand', theme.expandLabel);
          const initialLabel = btn.querySelector('.ug-pc__grid-cta__label');
          if (initialLabel && btn.getAttribute('aria-expanded') !== 'true') {
            initialLabel.textContent = theme.expandLabel;
          }
        }
        if (theme.collapseLabel) {
          btn.setAttribute('data-ug-pc-label-collapse', theme.collapseLabel);
        }

        btn.addEventListener('click', function () {
          const panel = btn.closest('.ug-pc-tabs__panel');
          if (!panel) return;
          const labelEl = btn.querySelector('.ug-pc__grid-cta__label');
          const textExpand = btn.getAttribute('data-ug-pc-label-expand') || '';
          const textCollapse = btn.getAttribute('data-ug-pc-label-collapse') || '';
          const isExpanded = panel.classList.toggle('is-grid-expanded');
          if (labelEl) {
            labelEl.textContent = isExpanded ? textCollapse : textExpand;
          }
          btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        });
      });
    });
  }

  window.__ugApplyProductCardTheme = function (scopeRoot) {
    applyGlobalTheme(scopeRoot || document);
    bindGridExpand(scopeRoot || document);
  };

  function scheduleApplyProductCardTheme(scopeRoot) {
    if (window.__ugProductCardThemeApplyPending) return;
    window.__ugProductCardThemeApplyPending = true;
    requestAnimationFrame(function () {
      window.__ugProductCardThemeApplyPending = false;
      window.__ugApplyProductCardTheme(scopeRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.__ugApplyProductCardTheme();
    });
  } else {
    window.__ugApplyProductCardTheme();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const host = event.target;
    const pc = host && host.querySelector && host.querySelector('.ug-pc-section');
    if (pc) {
      window.__ugApplyProductCardTheme(pc);
    } else {
      window.__ugApplyProductCardTheme();
    }
  });

  document.addEventListener('ug:product-card-theme:update', function (ev) {
    const r = ev.detail && ev.detail.root;
    if (r && r.classList && r.classList.contains('ug-pc-section')) {
      scheduleApplyProductCardTheme(r);
      return;
    }
    scheduleApplyProductCardTheme();
  });

  document.addEventListener('ug:product-card:mounted', function () {
    scheduleApplyProductCardTheme();
  });

  window.addEventListener('pageshow', function () {
    scheduleApplyProductCardTheme();
  });
  window.addEventListener('load', function () {
    scheduleApplyProductCardTheme();
  });

  if (!window.__ugProductCardThemeDomObserver) {
    window.__ugProductCardThemeDomObserver = new MutationObserver(function (mutations) {
      let shouldApply = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (shouldApply || node.nodeType !== 1) return;
          if (
            node.matches &&
            (node.matches('.ug-pc-section') ||
              node.matches('[data-ug-pc-theme-data]') ||
              node.matches('[data-ug-pc-theme-json]'))
          ) {
            shouldApply = true;
            return;
          }
          if (
            node.querySelector &&
            (node.querySelector('.ug-pc-section') ||
              node.querySelector('[data-ug-pc-theme-data]') ||
              node.querySelector('[data-ug-pc-theme-json]'))
          ) {
            shouldApply = true;
          }
        });
      });
      if (shouldApply) scheduleApplyProductCardTheme();
    });
    window.__ugProductCardThemeDomObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

(function () {
  if (window.__ugProductCardCodeCopy) return;
  window.__ugProductCardCodeCopy = true;

  document.addEventListener('click', function (e) {
    const btn = e.target && e.target.closest && e.target.closest('.ug-pc-card__code-copy');
    if (!btn || !btn.closest('.ug-pc-section')) return;

    const code = btn.getAttribute('data-code');
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        showCopied(btn);
      }).catch(function () {});
    } else {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
      } catch (err) {}
      document.body.removeChild(ta);
      showCopied(btn);
    }
  });

  function showCopied(btn) {
    btn.textContent = btn.getAttribute('data-copied-text') || 'Gekopieerd!';
    setTimeout(function () {
      btn.textContent = btn.getAttribute('data-copy-text') || 'Copy'; 
    }, 2000);
  }
})();
